import { TechnologiesDetailParser } from '@services/http/parsers/technologies-detail-response.parser';
import { SnfIntlHttpRemoteCall } from '../snf-intl.http-remote-call';

export class GetTechnologiesDetailRemoteCall extends SnfIntlHttpRemoteCall {
  /**
   * @inheritdoc
   */
  relativePath = 'tecnologies';

  /**
   * @inheritdoc
   */
  responseParser = new TechnologiesDetailParser();

  /**
   * @inheritdoc
   */
  constructor(id, language) {
    super(language);
    this.relativePath = `${this.relativePath}/${id}`;
  }

  cache = true;

  getQuery() {
    return {
      ...super.getQuery()
    };
  }
}
